import React from 'react';
import {
  IconDeviceMobile,
  IconBus,
  IconReceipt,
  IconTrendingUp,
  IconKey,
  IconCreditCard,
  IconBuildingBank,
  IconCash,
  IconBurger,
} from '@tabler/icons-react';

interface FeatureConfigItem {
  label: string;
  icon: React.ReactElement;
}

export const FEATURE_CONFIG: Record<string, FeatureConfigItem> = {
  phone_recharge: {
    label: 'Recarga de celular',
    icon: React.createElement(IconDeviceMobile),
  },
  sube_charge: {
    label: 'Carga SUBE',
    icon: React.createElement(IconBus),
  },
  services_payment: {
    label: 'Pago de servicios',
    icon: React.createElement(IconReceipt),
  },
  investments: {
    label: 'Inversiones',
    icon: React.createElement(IconTrendingUp),
  },
  prepaid_card_physical_pin: {
    label: 'Extracción ATM',
    icon: React.createElement(IconKey),
  },
  prepaid_card_physical_request: {
    label: 'Pedir tarjeta física',
    icon: React.createElement(IconCreditCard),
  },
  cashout_rapipago: {
    label: 'Extracción Rapipago',
    icon: React.createElement(IconBuildingBank),
  },
  cash_in: {
    label: 'Depósito de dinero',
    icon: React.createElement(IconCash),
  },
  cash_out: {
    label: 'Retiro de dinero',
    icon: React.createElement(IconCash),
  },
  lunch_icon: {
    label: 'Icono almuerzo',
    icon: React.createElement(IconBurger),
  },
};
